// extracted by mini-css-extract-plugin
export default {"header":"mC","light":"nC","dark":"oC","headertitle":"pC","fname":"qC","headerContent":"rC","right":"sC","descriptionwrapper":"tC","appear":"uC","second":"vC","third":"wC","forth":"xC"};
    if(module.hot) {
      // 1711717534547
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  